// nibble-web/src/components/SegmentedGaugeCard.tsx
import { MOBILE_BREAKPOINT } from "../config";
import styled from "../styles";
import theme from "../styles/theme";
import { Flex } from "./Flex";
import { ApprovalTimeIcon } from "./icons/ApprovalTimeIcon";

type Props = {
  percentage: number; // 0-100
  segments?: number;
  onClick?: () => void;
};

export function HealthGuage({ percentage, segments = 15, onClick }: Props) {
  const pct = Math.max(0, Math.min(100, Math.round(percentage)));
  const filled = Math.round((pct / 100) * segments);

  const barColor =
    pct === 0
      ? theme.color.button.secondaryBorder
      : pct < 75
      ? theme.color.warning
      : theme.color.constructive;

  return (
    <Wrap onClick={onClick}>
      <Flex align="center" gap="s">
        <Flex style={{ marginTop: -2 }} align="center" justify="center">
          <ApprovalTimeIcon color={barColor} width={18} />
        </Flex>
        <Bars>
          {Array.from({ length: segments }).map((_, i) => (
            <Bar
              key={i}
              filled={i < filled}
              barColor={barColor}
              data-filled={i < filled}
            />
          ))}
        </Bars>
      </Flex>
    </Wrap>
  );
}

const Wrap = styled(Flex)`
  max-width: 200px;
  margin-top: -3px;
  display: flex;
  flex-direction: column;
  overflow: visible;
  border-radius: 9999px;
  padding: ${(p) => p.theme.spacing.xs} ${(p) => p.theme.spacing.s};
  cursor: pointer;
  transition: box-shadow 150ms ease;
  align-items: center;

  &:hover {
    box-shadow: ${(p) => p.theme.shadow.cardHeavy};
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-top: 0;
  }
`;

const Bars = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(3px, 1fr);
  gap: 3px;
`;

const Bar = styled.div<{ filled: boolean; barColor: string }>`
  height: 10px;
  border-radius: 2px;
  background: ${(p) =>
    p.filled ? p.barColor : p.theme.color.button.secondaryBorder};
`;
